import { advancementModuleName } from '@shared/constants';

export { advancementModuleName };
export const advancementUploadModuleName = 'advancementUpload';
export const advancementUploadModuleNamespace = `${advancementModuleName}/${advancementUploadModuleName}`;
